import React, { Component } from 'react';
import { Modal, Spin, Tag } from 'antd';

import './index.less';

class MemberModalView extends Component {
  state = {  }

  handleCancel = () => {
    const { handleCancel } = this.props;

    handleCancel()
  }

  handleOk = () => {
    this.handleCancel();
  }

  render() {
    const { loading, userList, tagName, footer } = this.props;

    return (
      <Modal
        width={664}
        centered
        title="成员数量"
        visible
        footer={footer}
        // bodyStyle={{padding: 10}}
        onCancel={this.handleCancel}
        wrapClassName="modal-tag-member"
      >
        <Spin spinning={loading}>
          <div className="member-title"><span>{tagName}</span><span style={{color: '#999'}}>({userList.length}人)</span></div>
          <div className="member-wrap">
            <div className="member-content">
              {userList.map(item => {
                return <Tag color='#F4F4F4' className="member-tag" key={item.userId}><span>{item.userName}</span><span style={{color: '#999'}}>[{item.orgName}]</span></Tag>
              })}
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default MemberModalView;